import QuestionInputSort from "./QuestionInputSort";
import GelHackButton from "../gel/GelHackButton";
import common from "../../common";

export default class QuestionInputSortConversion extends QuestionInputSort {
    constructor(question, view) {
        super(question, view);

    }

	createOptionButton(value) {
		const a = P3.assets;
		const button = !PIXI.utils.isMobile.any ?
			GelHackButton.create(
				a.texture("ui_drop_in_area"),
				a.texture("ui_drop_in_area_highlight")) :
			P3.Button.create(
				a.texture("ui_drop_in_area"),
				a.texture("ui_drop_in_area_highlight"));

		button.value = value;
		button.animate = false;
		button.animateIcon = false;
		button.tint = common.config.debug && button.value === this._question.answer ? 0x00AA00 : 0xFFFFFF;

		button.label = new PIXI.Text(button.value.toString() + button.value.unit, {
			fontSize: this._fontSize, fontFamily: "Arial", fontWeight: "bold", fill: 0x0});
		button.label.position.set(0, 0);
		button.label.anchor.set(0.5, 0.5);
		button.label.resolution = 2;
		button.animation.addChild(button.label);
		return button;
	}

	calculateFontSize(options) {
		const min = 20;
		const max = 40;

		for (let i = 0; i < options.length; ++i) {
			const value = options[i];
			const str = value.toString() + value.unit;
			if (str.length >= 5) {
				return min;
			}
		}
		return max;
	}
}